{
  "version": "v4.0.0",
  "name": "RemoveLiquidity",
  "bytecodeTemplate": "01010300000010{0}{2}{3}a3{2}{0}{3}{4}{5}{6}13060e{1}01021818",
  "fieldsSig": {
    "names": [
      "sender",
      "router",
      "pairId",
      "liquidity",
      "amount0Min",
      "amount1Min",
      "deadline"
    ],
    "types": [
      "Address",
      "Router",
      "ByteVec",
      "U256",
      "U256",
      "U256",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}